export default {
    methods: {
        /**
         * Show a upgrade notification
         * Uses Modal
         */
        upgradeNotification(message = false) {
            let title = 'Power up 🔌';
            if(!message) {
                message = 'Uh-oh! Looks like you\'ve exhausted your mail magic. Time to upgrade and recharge your InboxGPT account\'s magic batteries. Let\'s power up!'
            }

            // if($auth.user().account.plan_name === 'Free') { => does not work, maybe later
            //     title = 'Please upgrade to our Paid Plan'
            //     message = 'You used up all quota in the free plan. Please upgrade to our Paid Plan to unlock all cool features!';
            // }

            this.$bvModal.msgBoxConfirm(message, {
                title: title,
                // size: 'sm',
                // buttonSize: 'sm',
                okVariant: 'primary',
                cancelVariant: 'hidden',
                okTitle: 'Start free trial',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
            })
                .then(value => {
                    if(value) {
                        this.$router.push('/account?upgrade');
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        }
    }
};